import MinimizeIcon from "../../Elements/Icons/MinimizeIcon";
import React from "react";

export default ({ className, onClick }) => (
  <button
    onClick={onClick}
    className={className}
    aria-label="Minimize chat widget"
    title="Minimize chat widget"
  >
    <MinimizeIcon />
  </button>
);
